<template>
  <div id="step-by-step">
      <div class="row mb-2 mt-2">
          <div class="col-lg" id="exampleQuestions">
              <div class="card mb-3">
                  <a class="card-header" data-toggle="collapse" href="#collapseEvent2"
                     aria-expanded="true" aria-controls="collapseEvent2"
                     style="color: ghostwhite; background-color: #5b8bb4">
                      <strong style="font-size: 24px">[STEP 1] Data creation</strong>
                  </a>
                  <div id="collapseEvent2" class="collapse show">
                      <div class="card-body" style="text-align: left">
                          <div id="step1-1" style="line-height: 180%;">
                            <strong style="font-size: 18px">1) Preliminary Data</strong><br/>
                            <div style="margin-left: 20px; margin-top: 10px; margin-bottom: 10px">
                              <strong>Question-Correct pair</strong> is given as preliminary data as follows:
                              <div id="table-base">
                                  <table style="margin-top: 10px; margin-bottom:10px;">
                                    <tbody>
                                      <tr style="background-color: white; border-bottom: 2px solid darkgrey;">
                                        <td style="width: 120px; text-align: center;">Question</td>
                                        <td style="width: 330px; padding-left: 10px;">To open a letter, </td>
                                      </tr>
                                      <tr style="background-color: white">
                                        <td style="text-align: center;">Correct</td>
                                        <td style="padding-left: 10px;">use a letter knife to open an edge.</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              <br/>
                            </div>
                          </div>

                          <div id="step1-2">
                              <strong style="font-size: 18px">2) Modify the wordings of Correct to form Incorrect</strong>
                              <div style="margin-left: 20px; margin-top: 10px; margin-bottom: 10px">
                                  With the provided Preliminary Data, Question-Correct pair, generate an Incorrect by substituting, adding, or deleting words from the existing Correct.
                                  There are <B>important conditions</B> that must be followed.<br/>
                                  <div style="margin-top: 20px; margin-bottom: 20px; line-height: 180%;">
                                    <B style="font-size: 18px;">First</B>, Specific wordings to the question which could become hints for distinguishing between candidates, should be mentioned only in one<br/>
                                    of the following situations: <br/>
                                    <div style="margin-left: 30px;">
                                      1) Both Correct AND Incorrect<br/>
                                      2) Neither Correct NOR Incorrect.<br/>
                                    </div>
                                    <B style="font-size: 18px;">Second</B>, Incorrect should be sentence with specific plausible content, not outrageous weirdness.<br/>
                                    <B style="font-size: 18px;">Third</B>, To maximize the similarity, wordings for the 'Incorrect' should be modified as little as possible from the 'Correct'.
                                  </div>
                                  You should produce a QA Data with all two conditions satisfied as follows:
                                  <div id="table-1-1">
                                    <table style="margin-top: 15px; margin-bottom:10px;">
                                      <tbody>
                                        <tr style="background-color: white; border-bottom: 2px solid darkgrey;">
                                          <td style="width: 120px; text-align: center;">Question</td>
                                          <td style="width: 330px; padding-left: 10px;">To open a letter, </td>
                                        </tr>
                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Correct</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: tomato"><del>letter</del> utility</strong> knife to open an edge.</td>
                                        </tr>
                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Incorrect</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: royalblue">foil cutter</strong> to open an edge.</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  Since the word 'letter' is missing in Incorrect, using the word 'letter' only in Question and Correct may become a hint to distinguish the Correct answer from the Incorrect.
                                  Therefore, you can see that we <strong>replaced the word 'letter' by 'utility' to satisfy the second condition.</strong><br/>
                                  <br/>
                              </div>
                          </div>

                          <div id="step1-3">
                              <strong style="font-size: 18px">3) Generate a New Question with Incorrect in Part 2)</strong><br/>
                              <img alt="make a question" src="./../assets/make_question.png" width="50%"><br/>
                              <div style="margin-left: 20px; margin-top: 10px; margin-bottom: 10px">
                                <strong>Construct a New Question by utilizing the previous Incorrect as Correct answer while treating Correct to the previous question as Incorrect answer.</strong>
                                Following the example mentioned in Part 1), Error-Choice (foil cutter) is an object used to open wine bottle, while it is difficult for Answer (utility knife) to open wine bottle.<br/><br/>
                                <img alt="foil cutter" src="./../assets/foil_cutter.png" width="23%">
                                <img alt="foil cutter" src="./../assets/utility_knife.png" width="23%" style="margin-left: 100px;">
                                <br/><br/>
                                By that, you can create <strong>two corresponding QA Data</strong> as shown in the table below.<br/>
                                <div style="margin-top: 20px; font-size: 18px; float: left">
                                  <strong>QA Data 1</strong>
                                </div>
                                <div style="margin-top: 20px; font-size: 18px; float: left; margin-left: 350px;">
                                  <strong>QA Data 2</strong>
                                </div>
                                <br/><br/>
                                <div id="table-2">
                                    <table style="margin-top: 5px; margin-bottom:10px; float: left;">
                                      <tbody>
                                        <tr style="background-color: white; border-bottom: 2px solid darkgrey;">
                                          <td style="text-align: center;">Question</td>
                                          <td style="padding-left: 10px;">To open a letter, </td>
                                        </tr>

                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Correct</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: tomato">utility knife</strong> to open an edge.</td>
                                        </tr>

                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Incorrect</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: royalblue">foil cutter</strong> to open an edge.</td>
                                        </tr>
                                      </tbody>
                                    </table>

                                    <a class="material-icons"
                                       style="font-size: 48px; float: left; color: black;
                                              margin-left: 15px; margin-right: 15px; margin-top: 60px;">
                                      shuffle
                                    </a>

                                    <table style="margin-top: 5px; margin-bottom:10px; float: left; border: 2px solid tomato">
                                      <tbody>
                                        <tr style="background-color: white; border-bottom: 2px solid darkgrey;">
                                          <td style="text-align: center;">New Question</td>
                                          <td style="padding-left: 10px;">To open a wine,</td>
                                        </tr>

                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Correct</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: royalblue">foil cutter</strong> to open an edge.</td>
                                        </tr>

                                        <tr style="background-color: white">
                                          <td style="text-align: center;">Incorrect</td>
                                          <td style="padding-left: 10px;">use a <strong style="color: tomato">utility knife</strong> to open an edge.</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    <br/><br/><br/><br/><br/><br/>
                                  </div>
                              </div>
                          </div>
                          <br/>

                          <div id="step1-4">
                              <strong style="font-size: 18px">4) Fail in QA Data generation, repeat step 2) and 3)</strong>
                              <div style="margin-left: 20px; margin-top: 10px; margin-bottom: 10px;">
                                If you cannot generate a New Question with the previous Incorrect,
                                you may need to start over again from step 2) to create another Incorrect,
                                which is able for generating corresponding question.<br/>
                              </div>
                          </div>
                      </div>
                  </div>
              </div><br/>
              <div class="card mb-3">
                  <a class="card-header" data-toggle="collapse" href="#collapseEvent3"
                     aria-expanded="true" aria-controls="collapseEvent3"
                     style="color: ghostwhite; background-color: #5b8bb4">
                      <strong style="font-size: 24px">[STEP 2] Data validation</strong>
                  </a>
                  <div id="collapseEvent3" class="collapse show">
                      <div class="card-body">
                          <div class="card-text" style="text-align: left">
                              Data validation is a step for verifying whether the data created in [STEP 1] satisfies all the conditions.<br/>
                              <div id="table-3">
                                  <table style="margin-top: 10px; margin-bottom:10px; float: left;">
                                    <tbody>
                                      <tr style="background-color: #ffe8de; border-bottom: 2px solid darkgrey;">
                                        <td style="text-align: center;">Question</td>
                                        <td style="padding-left: 10px;">To open a letter, </td>
                                      </tr>
                                      <tr style="background-color: white">
                                        <td style="text-align: center;">Correct</td>
                                        <td style="padding-left: 10px;">use a <strong style="color: tomato">utility knife</strong> to open an edge.</td>
                                      </tr>
                                      <tr style="background-color: white">
                                        <td style="text-align: center;">Incorrect</td>
                                        <td style="padding-left: 10px;">use a <strong style="color: royalblue">foil cutter</strong> to open an edge.</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <table style="margin-left: 20px; margin-top: 10px; margin-bottom:10px; float: left">
                                    <tbody>
                                      <tr style="background-color: #e2efff; border-bottom: 2px solid darkgrey;">
                                        <td style="text-align: center;">New Question</td>
                                        <td style="padding-left: 10px;">To open a wine,</td>
                                      </tr>

                                      <tr style="background-color: white">
                                        <td style="text-align: center;">Correct</td>
                                        <td style="padding-left: 10px;">use a <strong style="color: royalblue">foil cutter</strong> to open an edge.</td>
                                      </tr>

                                      <tr style="background-color: white">
                                        <td style="text-align: center;">Incorrect</td>
                                        <td style="padding-left: 10px;">use a <strong style="color: tomato">utility knife</strong> to open an edge.</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <br/><br/><br/><br/><br/><br/>
                              </div>
                              <strong style="font-size: 18px">1. Check whether the correct answer can be clearly distinguished from Incorrect.</strong><br/>
                              <br/>
                              <strong style="font-size: 18px">2. Make sure that specific wordings to the question is mentioned in only one of the following situations.</strong><br/>
                              <div style="margin-left: 20px; margin-top: 5px; line-height: 180%"><strong>
                                1) Both Correct AND Incorrect.<br/>
                                2) Neither Correct NOR Incorrect.<br/>
                              </strong></div>
                              <br/>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'StepByStep',
  props: {
      max_bonus: Number,
      bonus_per_question: Number
  },
}
</script>


<style scoped>
    #StepByStep {
    }

    .card {
      background-color: white;
    }
    .card-header {
      background-color: ghostwhite;
      /*color: blueviolet;*/
    }
    .card-text {
      margin-left: 20px;
      margin-right: 20px;
    }

    table {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: auto;
        margin-bottom: 20px;
        background-color: aliceblue;
    }
    td {
        border: 1px solid lightsteelblue;
        text-align: left;
        padding: 8px;
    }

</style>